import { GET_MEDIUM_DATA_PENDING, GET_MEDIUM_DATA_SUCCESS, GET_MEDIUM_DATA_ERROR, GET_MEDIUM_DATA_INIT } from './types'
import initialState from './initialState'

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_MEDIUM_DATA_INIT:
      return {
        ...state,
        pending: false,
        success: false,
        error: false,
        data: null
      }

    case GET_MEDIUM_DATA_PENDING:
      return {
        ...state,
        pending: true,
        success: false,
        error: false,
        data: null
      }

    case GET_MEDIUM_DATA_SUCCESS:
      return {
        ...state,
        pending: false,
        success: true,
        error: false,
        data: action.data
      }

    case GET_MEDIUM_DATA_ERROR:
      return {
        ...state,
        pending: false,
        success: false,
        error: true,
        data: null
      }

    default:
      return state
  }
}

export default reducer